import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">THE IMPACT PENDULUM</span>
                                            </div>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/imp_pendulum.png')}
                                                    alt=""/>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>stages of impact</div>
                                            <div className="border_subtitle">Stage 1– Develop self-awareness
                                            </div>
                                            <div className="paraspace"><p
                                                style={{paddingBottom:'0px !important'}}>To begin to develop your
                                                impact you need ‘self-awareness’ of your effect on other people.
                                                Choose someone who you have the opportunity to make a more
                                                positive impact on than you do at present. This could be a
                                                manager, a colleague, a customer or indeed someone in your
                                                personal life. Ask yourself:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>What do I know about my own impact on them?</li>
                                                <li>How do they perceive me?</li>
                                                <li className="list-bottom-pad">Why am I motivated to better
                                                    understand my impact on this person?
                                                </li>

                                            </ul>
                                            <p>Asking yourself the above questions can help you to understand
                                                what you think you know, what the reality is and why you want to
                                                change your impact on this person.</p>

                                            <div className="border_subtitle">Stage 2 – Identify your desired
                                                impact
                                            </div>
                                            <div className="paraspace"><p
                                                style={{paddingBottom:'0px !important'}}>The next stage will be to
                                                try to identify what type of impact you would like to have on
                                                this person.
                                                You can do this by identifying an individual who you perceive to
                                                have a positive impact on others.
                                                The key questions you should ask yourself about this person
                                                are:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>What do they do that makes a positive impact?</li>
                                                <li>What is the outcome of their positive impact?</li>
                                                <li>If they had a similar style to me, how would the impact have
                                                    been different?
                                                </li>
                                                <li className="list-bottom-pad">Which types of people or
                                                    situations do I find most difficult to have a positive
                                                    impact on?
                                                </li>

                                            </ul>

                                            <div className="buttonposition">
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page2')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page4')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }